import parseDateIntoString from '@stencil/hotels-utils/src/date-utils/parse-date-into-hermes-string';
import {
  getCookie,
  setCookie,
  getDeviceID,
  isLoggedIn,
  titlesMap,
  getCmpCookieValue,
  getUpdatedContext,
  generateUUID,
  getJourneyId,
  getRequestId,
  getSessionId,
  getSearchType,
} from '@stencil/hotels-utils/src/common-utils';
import {getDayuseDefaultCheckinTime} from '@stencil/hotels-utils/src/date-utils/date-utils';
import {prepareRoomStayCandidatesCG} from '@stencil/hotels-utils/src/prepare-cg-pax-data';
import {appConfig} from '@stencil/hotels-config';
import splitRoomString from '@stencil/hotels-utils/src/split-room-string';

const NEAR_BY_CITY_RADIUS = 100000;

export const hasWebpSupport = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  var elem = document.createElement('canvas');

  if (!!(elem.getContext && elem.getContext('2d'))) {
    // was able or not to get WebP representation
    return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
  }

  // very old browser like IE 8, canvas not supported
  return false;
};

export const isSEMDate = dateString => dateString.indexOf('date_') !== -1;

export const convertMMTDate = dateString => {
  if (dateString) {
    const formattedDateString = parseDateIntoString(dateString?.date, 'yyyy-mm-dd');
    // if (isSEMDate(dateString)) {
    //   const dateComponents = dateString.split('_');
    //   const dateObj = new Date();
    //   let days = 0;
    //   try {
    //     days = parseInt(dateComponents[1], 10);
    //   } catch (e) {
    //     // eslint-disable-next-line
    //   }
    //   dateObj.setDate(dateObj.getDate() + parseInt(days, 10));
    //   return parseDateIntoString(dateObj, 'YYYY-MM-DD');
    // }
    return formattedDateString;
  }
  return null;
};

export const getVisitNumber = () => {
  const timeNow = new Date().getTime();
  const visitNumberItem = getCookie('visitNumber');
  const time = 609 * 24 * 60; // minutes in 2 year
  if (visitNumberItem) {
    const visitObj = JSON.parse(visitNumberItem);
    if (timeNow - visitObj.time > 30 * 60 * 1000) {
      visitObj.number += 1;
    }
    visitObj.time = timeNow;
    setCookie('visitNumber', JSON.stringify(visitObj), time);
    // docLocalStorage.setItem('visitNumber');
    return visitObj.number;
  }
  setCookie(
    'visitNumber',
    JSON.stringify({
      number: 1,
      time: timeNow,
    }),
    time,
  );

  return 1;
};

export const getFunnelSource = ({homeStay, isDayUse = false}) => {
  let funnelSource = 'HOTELS';
  // if (commonMethods.isCorpFlow()) {
  // not using this for CORP as of now.
  //   return 'CORP';
  // }
  if (isDayUse) {
    funnelSource = 'DAYUSE';
  }
  if (homeStay) {
    funnelSource = 'HOMESTAY';
  }
  return funnelSource;
};

export const getDeviceDetail = isDesktop => ({
  appVersion: '108.0', //isDesktop ? getBrowserVersion() || '7.2.5' : '7.2.5',
  deviceId: getDeviceID(),
  deviceType: isDesktop ? 'Desktop' : 'Mobile',
  bookingDevice: isDesktop ? 'DESKTOP' : 'PWA',
});

export const getSearchCriteria = ({
  urlParams: {
    hotelId,
    checkin,
    checkout,
    roomStayQualifier,
    country = 'in',
    city,
    locusId,
    locusType,
    _uCurrency = 'INR',
    tripType,
    personalBooking,
    mtkeys,
    cityId,
    giHotelId,
    topHtlId,
    sType,
  },
  urlParams,
  comparatorHotelIds = [],
  selectedCurrency,
  travellerEmailId,
  roomCriteria = [],
  searchType = '',
  isMobLanding = false,
}) => {
  const checkIn = convertMMTDate(checkin);
  const checkOut = convertMMTDate(checkout);
  const roomStayCandidates = prepareRoomStayCandidatesCG(roomStayQualifier);
  let obj = {};
  if (roomCriteria?.length) {
    obj['roomCriteria'] = roomCriteria;
  }
  if (searchType) {
    obj['searchType'] = searchType;
  }
  if (hotelId) {
    obj['hotelId'] = hotelId;
  }
  return {
    // hotelId: hotelId || '',
    // hard coded needs to be handled once integrated
    // hotelId: '3594639680709734462',
    // hard coded needs to be handled once integrated
    // giHotelId: '3594639680709734462',
    // vcId: '8717279093827200968',
    vcId: isMobLanding && !cityId ? '' : cityId || '2820046943342890302',
    //to be removed once vcid dependency is not needed
    giHotelId, //
    // hotelId: hotelId || '', // hard coded needs to be handled once integrated
    checkIn,
    checkOut,
    roomStayCandidates,
    comparatorHotelIds,
    countryCode: country,
    cityCode: isMobLanding && !locusId ? 'CTDUMMY' : '',
    locationId: isMobLanding && !locusId ? 'CTDUMMY' : locusId || 'RGNCR',
    locationType: isMobLanding && !locusType ? 'city' : locusType || 'region',
    currency: selectedCurrency || _uCurrency,
    limit: 20,
    tripType,
    travellerEmailID: travellerEmailId,
    mtKey: mtkeys,
    personalCorpBooking: !!personalBooking,
    ...obj,
    userSearchType: getSearchType(urlParams),
  };
};

export const getSearchCriteriaForSRP = ({
  urlParams: {
    checkin,
    checkout,
    roomString,
    country = 'IN',
    _uCurrency = 'INR',
    cityId,
    locus,
    isDayUse = false,
    // locusId,
    // locusType,
  },
  selectedCurrency,
  lastFetchedWindowInfo = '',
}) => {
  const checkIn = convertMMTDate(checkin);
  const checkOut = convertMMTDate(isDayUse ? checkin : checkout);
  const roomStayCandidates = prepareRoomStayCandidatesCG(roomString);
  const {id, type, cityCode} = locus || {};
  let obj = {};
  if (lastFetchedWindowInfo) {
    obj['lastFetchedWindowInfo'] = lastFetchedWindowInfo;
  }
  return {
    vcId: cityId || '2820046943342890302',
    //to be removed once vcid dependency is not needed
    checkIn,
    checkOut,
    roomStayCandidates,
    countryCode: country || 'IN',
    cityCode: cityCode,
    locationId: id,
    locationType: type,
    currency: selectedCurrency || _uCurrency,
    limit: 10,
    ...obj,
  };
};

export const getSearchCriteriaForReviewPg = ({
  isDayUse,
  urlParams: {
    hotelId,
    checkin,
    checkout,
    roomStayQualifier,
    country = 'in',
    city,
    locusId,
    locusType,
    _uCurrency = 'INR',
    tripType,
    personalBooking,
    mtkeys,
    cityId,
    giHotelId,
    suppDetail,
    mtKey,
    searchType,
    slot,
  },
  urlParams,
  comparatorHotelIds = [],
  selectedCurrency,
  travellerEmailId,
  roomCriteria = [],
  checkUpgrade = false,
  // searchType = 'E',
}) => {
  const checkIn = convertMMTDate(checkin);
  const checkOut = convertMMTDate(checkout);
  const roomStayCandidates = prepareRoomStayCandidatesCG(roomStayQualifier);
  let obj = {};
  if (roomCriteria?.length) {
    obj['roomCriteria'] = roomCriteria;
  }
  if (searchType) {
    obj['searchType'] = searchType;
  }
  if (hotelId) {
    obj['hotelId'] = hotelId;
    // obj['hotelId'] = '201403191129397088';
  }
  if (isDayUse) {
    obj['slot'] = slot;
  }
  return {
    // hotelId: '6667777867648572175', // hard coded needs to be handled once integrated
    // giHotelId: '6667777867648572175',
    // vcId: '8717279093827200968',
    vcId: cityId || '2820046943342890302', //to be removed once vcid dependency is not needed
    giHotelId,
    // giHotelId: '201403191129397088_test',
    // hotelId: '201403191129397088',
    // hotelId: hotelId || '', // hard coded needs to be handled once integrated
    checkIn,
    checkOut,
    roomStayCandidates: [
      {
        rooms: 1,
        adultCount: 2,
        childAges: [],
      },
    ],
    comparatorHotelIds,
    countryCode: country,
    cityCode: city,
    locationId: locusId || 'RGNCR',
    locationType: locusType || 'region',
    currency: selectedCurrency || _uCurrency,
    limit: 20,
    tripType,
    travellerEmailID: travellerEmailId,
    mtKey: mtkeys,
    personalCorpBooking: !!personalBooking,
    ...obj,
    checkUpgrade: checkUpgrade,
    userSearchType: getSearchType(urlParams),
  };
};

export interface SearchCriteriaSRP {
  urlParams: {
    checkin: string;
    checkout: string;
    locus: {
      id: string;
      type: string;
      cityCode?: string;
    };
    _uCurrency?: string;
    roomString?: string;
    checkinTime?: number;
    selectedSlot?: string;
    isDayUse?: boolean;
    country?: string;
  };
  lastHotelId?: string;
  lastHotelCategory?: string;
  lastFetchedWindowInfo?: string;
}

export const getSearchCriteriaSRP = ({
  urlParams: {
    checkin = '',
    checkout = '',
    locus = {id: '', type: '', cityCode: ''},
    _uCurrency = 'INR',
    roomString = '',
    checkinTime = 1000,
    selectedSlot = '',
    isDayUse = false,
    country = 'IN',
    nearLocus = false,
    lat,
    lon,
    limit,
    mmtId = '',
    sType = '',
  } = {},
  urlParams,
  lastHotelId = '',
  lastHotelCategory = '',
  lastFetchedWindowInfo = '',
  personalizedSearch = true,
}) => {
  const {id = '', type = '', cityCode = ''} = locus || {};
  const checkIn = convertMMTDate(checkin);
  const checkOut = convertMMTDate(checkout);
  const slot = {} as {
    timeSlot: number;
    duration?: number | string;
  };
  if (isDayUse) {
    slot.timeSlot = checkinTime / 100;
    if (selectedSlot) {
      slot.duration = selectedSlot;
    }
  }

  let nearByParams = {};
  if (nearLocus) {
    nearByParams = {
      nearBySearch: nearLocus,
      lat,
      lng: lon,
    };
  }

  return {
    checkIn: checkIn,
    checkOut: isDayUse ? checkIn : checkOut,
    countryCode: country || 'IN',
    currency: _uCurrency || 'INR',
    hotelIds: [],
    lastHotelId,
    lastHotelCategory,
    lastFetchedWindowInfo,
    limit: limit || 10,
    locationId: id,
    locationType: type,
    cityCode: cityCode,
    personalCorpBooking: false,
    personalizedSearch: personalizedSearch,
    roomStayCandidates: prepareRoomStayCandidatesCG(roomString),
    slot,
    totalHotelsShown: 0,
    ...nearByParams,
    userSearchType: getSearchType(urlParams, true),
  };
};

// export const getJourneyId = ({checkin, checkout, locusId, roomStayQualifier}) => {
//   let obj = {
//     checkin: checkin?.date ? dateTransformUtil(checkin?.date, 'mmddyyyy') : '',
//     checkout: checkout?.date ? dateTransformUtil(checkout?.date, 'mmddyyyy') : '',
//     locusId: locusId,
//     roomStayQualifier: roomStayQualifier,
//   };
//   const currentContext = getUpdatedContext(obj);
//   return {journeyId: `${currentContext}${getDeviceID()}`};
// };

// export const getRequestId = () => {
//   return {requestId: generateUUID()};
// };

export const getRequestDetails = ({
  urlParams = {
    trafficSrc: '',
    funnelType: '',
    homeStay: '',
    isExtendedPackageCall: '',
    zcp: '',
    payMode: '',
    checkin: {},
    checkout: {},
    roomStayQualifier: '',
    locusId: '',
    roomString: '',
  },
  paymentMode = '',
  pageContext = 'DETAIL',
  isDayUse = false,
  cmpValue = '',
  sessionIdValue = '',
  deviceIdVal = '',
}) => {
  const {
    trafficSrc,
    funnelType,
    homeStay,
    isExtendedPackageCall,
    zcp,
    payMode,
    checkin,
    checkout,
    roomStayQualifier,
    locusId,
  } = urlParams;
  let trafficSourceObj = {};
  try {
    const cmpCookieValue = cmpValue || getCmpCookieValue();
    if (cmpCookieValue) {
      trafficSourceObj = {
        trafficSource: {
          type: 'CMP',
          source: cmpCookieValue,
        },
      };
    }
  } catch (error) {
    console.log('Exception while setting trafficSourceObj::', error);
  }

  const deviceId = deviceIdVal || getDeviceID();
  const journeyId =
    getJourneyId({
      checkin,
      checkout,
      roomStayQualifier,
      locusId,
      deviceIdVal: deviceId,
    }) || {};
  const requestId = getRequestId();
  const sessionId = {sessionId: sessionIdValue} || getSessionId();

  return {
    visitorId: deviceId,
    visitNumber: getVisitNumber(),
    loggedIn: isLoggedIn(),
    couponCount: 3,
    funnelSource: getFunnelSource({homeStay, isDayUse}),
    idContext: 'B2C',
    pageContext,
    channel: 'B2Cweb',
    brand: 'GI',
    siteDomain: 'in',
    payMode: paymentMode || payMode,
    ...trafficSourceObj,
    ...journeyId,
    ...requestId,
    ...sessionId,
  };
};

export const prepareRoomCriteriaFromUrlCG = (
  roomCriteria: any,
  supplierCode: any,
  mtKey: string,
) => {
  const roomCriteriaMap = new Map();
  if (roomCriteria) {
    roomCriteria?.split('~~~')?.forEach((val: string) => {
      const arr = val.split('~|~');
      if (arr?.[0]?.length) {
        roomCriteriaMap.set([`${arr[0]}-${arr[1]}`], {
          roomCode: arr[0],
          ratePlanCode: arr[1],
          supplierCode: arr[2],
          mtKey: arr[3].replace(/~~$/, ''),
          roomStayQualifier: arr[4],
          isLucky: arr[5]?.toLowerCase() === 'true',
        });
      }
    });
  }
  return prepareRoomCriteriaCG(roomCriteriaMap, supplierCode);
};

export const prepareRoomCriteriaCG = (roomMap, supplierCode) => {
  const roomCriteriaList = [];
  roomMap.forEach(val => {
    const roomCriteria = {
      ratePlanCode: val.ratePlanCode,
      pricingKey: val.pricingKey,
      roomCode: val.roomCode,
      mtKey: val.mtKey || null,
      roomStayCandidates: getCandidatesForAvailCG(val.roomStayQualifier),
      supplierCode: val?.supplierCode,
      isLucky: val?.isLucky,
    };
    roomCriteriaList.push(roomCriteria);
  });
  return roomCriteriaList;
};

export const getCandidatesForAvailCG = (roomStayQualifier = '') => {
  if (!roomStayQualifier || roomStayQualifier.indexOf('e') === -1) {
    return [
      {
        adultCount: 2,
        childAges: [],
      },
    ];
  }
  const roomStayCandidatesList = [];
  const rmStayTokens = roomStayQualifier.split('e');
  for (let i = 0; i < rmStayTokens.length - 1; ) {
    const roomStayCandidate = {};
    const adultCount = rmStayTokens[i++];
    roomStayCandidate.adultCount = adultCount;
    const childCount = rmStayTokens[i++];
    if (childCount > 0) {
      const childrenAges = [];
      for (let j = 0; j < childCount; j += 1) {
        const childAge = rmStayTokens[i++];
        childrenAges.push(childAge);
      }
      roomStayCandidate.childAges = childrenAges;
    }
    roomStayCandidatesList.push(roomStayCandidate);
  }
  return roomStayCandidatesList;
};

export const getRoomStayCandidatesListWithAgeQualifying = roomCandidateList => {
  let arr = [];
  for (let i = 0; i < roomCandidateList?.length; i++) {
    let roomTariff = roomCandidateList[i];
    let groupAgeArr = [];

    if (roomTariff?.adultCount) {
      let obj = {
        count: '2',
        ageQualifyingCode: '10',
        ages: [],
      };
      groupAgeArr.push(obj);
    }
    if (roomTariff?.childAges?.length) {
      let obj = {
        count: '2',
        ageQualifyingCode: '8',
        ages: roomTariff?.childAges,
      };
      groupAgeArr.push(obj);
    }
    arr.push({
      guestCounts: groupAgeArr,
      positionsForAgeLessThan1: [],
    });
  }
  return arr;
};

export const getCharityAddOn = data => {
  const {addon} = data;
  const apply = addon?.apply;
  const {addOnType, bucketId, id, title, validFrom} = {...addon};
  const addons = {
    addOnType,
    bucketId,
    id,
    title,
    unitSelected: apply ? {adult: 1, child: 0} : {adult: 0, child: 0},
    validFrom,
  };

  return addons;
};

export const getInsuranceAddOn = (insurancData = {}) => {
  const {data, adultCount, childCount, id, bucketId} = insurancData;

  if (!data || !data?.length) return {};

  let totalAdulCount = 0;
  let totalChildCount = 0;

  let insuranceObj = {
    addOnType: 'INSURANCE',
    id,
    bucketId,
  };

  let insuranceDataSelected = [];

  data.map(item => {
    let obj = {
      id: item?.id,
      unitSelected: {
        adult: adultCount,
        child: childCount,
      },
      totalPrice: item?.totalPrice,
      endDate: item?.endDate,
      startDate: item?.startDate,
    };

    totalAdulCount += adultCount;
    totalChildCount += childCount;

    insuranceDataSelected.push(obj);
  });

  insuranceObj['insuranceDataSelected'] = insuranceDataSelected;
  insuranceObj['insuranceDataSelected'] = insuranceDataSelected;

  insuranceObj['unitSelected'] = {
    adult: totalAdulCount,
    child: totalChildCount,
  };

  return insuranceObj;
};

const getGenderFromTitle = title => {
  let gender = 'MALE';

  let arr = titlesMap.filter(item => item?.value == title);
  if (arr.length > 0) {
    gender = arr[0]?.gender;
  }

  return gender;
};

export const getTravellerData = (
  nameDetails,
  email,
  countryCode,
  mobileNo,
  gstNumber,
  companyName,
  companyAddress,
  isBusinessProfile = false,
) => {
  let rCode = 0;
  const travellerData = Boolean(nameDetails?.length)
    ? nameDetails
        .filter((item, index) => {
          return index === 0
            ? !!item?.firstName && !!item?.lastName
            : !!item[`firstName${index}`] && !!item[`lastName${index}`];
        })
        .map((nameDetail, index) => {
          const dataAdaptor = {
            firstName: nameDetail[index === 0 ? 'firstName' : `firstName${index}`],
            lastName: nameDetail[index === 0 ? 'lastName' : `lastName${index}`],
            title: nameDetail.nameTitle || '1',
            room_code: (++rCode).toString(),
            masterPax: index === 0,
            emailID: email,
            gender: getGenderFromTitle(nameDetail.nameTitle || '1'),
            gstinCompanyAddress: isBusinessProfile ? companyAddress : '',
            gstinCompanyName: isBusinessProfile ? companyName : '',
            isdCode: countryCode,
            mobileNo: mobileNo,
            panCard: null,
            paxType: 'ADULT',
            registerGstinNum: isBusinessProfile ? gstNumber : '',
          };

          if (index === 0) {
            Object.assign(dataAdaptor, {is_master_pax: true});
          }

          return dataAdaptor;
        })
    : [];
  return travellerData;
};

export const getUrlParams = (common, hotelId, mmtHotelId = '', isDayUse = false) => {
  const vhid = hotelId;
  const {
    destination,
    locus,
    checkin,
    checkout,
    roomString,
    selectedHotel,
    country,
    topHtlId,
    sType,
    requestQuery,
    mmtId,
  } = common;

  return {
    mmtId,
    trafficSrc: null,
    funnelType: '',
    homeStay: '',
    isExtendedPackageCall: '',
    zcp: '',
    hotelId: mmtId || mmtHotelId,
    checkin: checkin,
    checkout: isDayUse ? checkin : checkout,
    roomStayQualifier: roomString,
    country: country,
    city: '',
    locusId: locus?.id,
    locusType: locus?.type,
    _uCurrency: 'INR',
    tripType: '',
    personalBooking: '',
    cityId:
      selectedHotel?.vcid || destination?.ct?._id || destination?.dest?._id || destination?._id,
    giHotelId: vhid,
    topHtlId,
    sType,
    isSEO: requestQuery?.isSeoV2 || requestQuery?.isSEO || false,
  };
};
export const getFilterCriteria = ({appliedFilters}) => {
  const filterCriteria = [];

  Object.keys(appliedFilters).forEach(filterGroup => {
    const filtersList = appliedFilters[filterGroup];
    if (filtersList?.length > 0) {
      filtersList.map(filterObj => {
        const {min, max, value} = filterObj;
        const filter = {
          filterGroup,
          filterValue: value || null,
          filterRange:
            min !== undefined
              ? {
                  minValue: min,
                  maxValue: max,
                }
              : null,
          isRangeFilter: false,
        };
        filterCriteria.push(filter);
      });
    }
  });
  return filterCriteria;

  // TODOS
  // const isPriceBucketFilter = group === 'HOTEL_PRICE_BUCKET';
  // const isPoiDistanceFilter = group === POI_DISTANCE_FILTER;
  // if (isPriceBucketFilter) {
  //   filterVal.forEach(priceVal => {
  //     const priceMinMaxValue = priceVal.split('-');
  //     const filterObj = prepareRangeFilterObj(
  //       Number(priceMinMaxValue[0]),
  //       isNaN(Number(priceMinMaxValue[1]))
  //         ? PRICE_FILTER_DEFAULT_SETTINGS.RANGE_TILL
  //         : Number(priceMinMaxValue[1]),
  //       group,
  //     );
  //     filterCriteria.push(filterObj);
  //   });
  // } else if (isPoiDistanceFilter) {
  //   const distanceRange = filterVal[0].split('-');
  //   const filterObj = prepareRangeFilterObj(
  //     Number(distanceRange[0]),
  //     Number(distanceRange[1]),
  //     group,
  //   );
  //   if (urlParams.mmPoiTag) {
  //     urlParams.mmPoiTag.split('~').forEach(val => {
  //       const {placeId} = mmtLocationHelper(val);
  //       filterObj.filterValue = placeId;
  //     });
  //   }
  //   filterCriteria.push(filterObj);
  // }
};

export const getMatchMakerDetails = ({
  appliedLocations,
  parsedConfig: {mmtId: urlMmtId = ''} = {},
  mmtId = '',
}) => {
  const matchMakerDetails = {
    selectedTags: [],
    latLng: [],
    hotels: mmtId || urlMmtId ? [{hotelId: mmtId || urlMmtId}] : [],
  };

  Object.keys(appliedLocations).forEach(filterGroup => {
    const filtersList = appliedLocations[filterGroup];
    if (!filtersList?.length) return;

    filtersList.forEach(filterObj => {
      const {n, loc_id, id_type, la, lo} = filterObj;
      const filter = {latitude: la, longitude: lo};

      // Handle different id_types more efficiently
      switch (id_type) {
        case 'area':
          matchMakerDetails.selectedTags.push({
            tagAreaId: loc_id,
            tagDescription: n,
            ...filter,
          });
          break;
        case 'poi':
          matchMakerDetails.latLng.push({
            name: n,
            poiId: loc_id,
            ...filter,
          });
          break;
        case 'nearme':
          matchMakerDetails.latLng.push({
            name: n,
            isPrimary: true,
            giNearBySearch: true,
            autoSuggestType: loc_id,
            ...filter,
          });
          break;
        case 'ggl_id':
          matchMakerDetails.latLng.push({
            name: n,
            placeId: loc_id,
            ...filter,
          });
          break;
        default:
          break;
      }
    });
  });

  return matchMakerDetails;
};

export const getDayUseDetailsSlotsData = ({
  common: {
    checkinTime = getDayuseDefaultCheckinTime(),
    selectedSlot = 3,
    vcid: vcId = '',
    checkin = {},
    roomString = '1-2-0',
  } = {},
  selectedHotelId = '',
}) => {
  const updatedTime = parseInt(checkinTime) / 100;
  const slot = {
    duration: selectedSlot,
    timeSlot: updatedTime,
  };
  const {paxCount, childAgeArray} = splitRoomString(roomString);
  return {
    giHotelId: selectedHotelId,
    vcId,
    checkIn: convertMMTDate(checkin),
    checkOut: convertMMTDate(checkin),
    roomStayCandidates: [
      {
        adultCount: paxCount,
        childAges: childAgeArray,
      },
    ],
    personalCorpBooking: false,
    limit: 0,
    slot,
  };
};

export const getNearbyFilter = ({urlParams}) => {
  const {locusId, locusType, country} = urlParams;
  return {
    excludeLocations: [
      {
        locationId: locusId,
        locationType: locusType,
      },
    ],
    includeCountries: [country],
    radius: NEAR_BY_CITY_RADIUS,
  };
};
